import { Component, OnInit, Input } from "@angular/core";
import { checkPostIsNew } from "@frontend/unhideschool/app/helpers/utility-functions";

@Component({
  selector: "unh-mosaico-item-square",
  templateUrl: "./mosaico-item-square.component.html",
  styleUrls: ["./mosaico-item-square.component.scss"],
})
export class MosaicoItemSquareComponent implements OnInit {
  @Input() link: any;
  @Input() title: any;
  @Input() comingsoon: any;
  @Input() instructorname: any;
  @Input() cover: any;
  @Input() instructorpicture: any;
  @Input() datepublished: any;

  isNew = false;

  ngOnInit(): void {
    this.isNew = this.checkPostIsNew(this.datepublished, 60);
  }

  checkPostIsNew(datePublished: string, maxDays: number) {
    return checkPostIsNew(datePublished, maxDays);
  }
}
